import '~/jssrc/jquery_global';
import '~/jssrc/select2_setup';
import '~/jssrc/layout';

import 'summernote/dist/summernote-bs5.js';
import "chartkick/chart.js"
import 'jquery-treegrid/js/jquery.treegrid.js';

import '~/jssrc/multi_file_upload';
import '~/jssrc/bootstrap-slider';
import '~/jssrc/jqmodal';
import '~/jssrc/ui_element_hooks';
import '~/jssrc/skills';
import '~/jssrc/talents';
import '~/jssrc/candidates';
import '~/jssrc/resumes';
import '~/jssrc/base_ext';
import '~/jssrc/ai_jd';
import '~/jssrc/ai_email_draft';
import '~/jssrc/bootstrap_tooltips';
import '~/jssrc/ai_score_tooltip';
import '~/jssrc/notifications';
import '~/jssrc/undo_toast';
import '~/jssrc/bulk_actions';

import RailsUJS from '@rails/ujs';
RailsUJS.start();  //if (!window._rails_loaded)

import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers";
const stimulus_app  = Application.start();  //stimulus_app.debug = true
const controllers = import.meta.glob("~/**/*_controller.js", {eager: true});
registerControllers(stimulus_app, controllers);
